// extracted by mini-css-extract-plugin
export default {"container":"LpWordCloudReport_container__oxpUz","noDataAvailable":"LpWordCloudReport_noDataAvailable__R-ZUC"};